import { faWindowMaximize } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ControlPosition, MapControl } from "@vis.gl/react-google-maps";
import NearByAssets from "../mapComponents/NearByAssets";
import HashTagFilter from "../mapComponents/HashTagFilter";
import CategoryFilter from "../mapComponents/CategoryFilter";
import useSrlHelper from "../../hooks/useSrlHelper";
import useAuth from "../../hooks/useAuth";

const ButtonsControl = ({
  report,
  nearbyItems,
  hashtag,
  setHashtag,
  category,
  setCategory,
  handleAll,
  showNearByAssets = true,
  showAllLabels = true,
  showHashTagFilter = false,
  showCategoryFilter = false,
}) => {
  const { isSrl } = useSrlHelper();
  const { user } = useAuth();
  const onSetFilter = (tags) => {
    setHashtag(tags);
  };

  if (
    !showNearByAssets &&
    !showAllLabels &&
    !showHashTagFilter &&
    !showCategoryFilter
  )
    return null;

  return (
    <MapControl position={ControlPosition.LEFT_TOP}>
      <div
        // className="d-flex align-items-center bg-white rounded border border-black border-1"
        // style={{ width: "auto", margin: "10px", padding: "5px" }}
        className="d-flex align-items-center"
        style={{
          background: "#ffffffff",
          width: "auto",
          margin: "10px",
          height: "40px",
          borderRadius: "2px",
          order: 1,
        }}
      >
        {showNearByAssets && <NearByAssets result={nearbyItems ?? []} />}
        {showAllLabels && user.role !== "Root" && (
          <div
            onClick={() => {
              handleAll && handleAll();
            }}
            className="cursor-pointer"
          >
            <FontAwesomeIcon
              className="mx-2"
              title={"All labels"}
              // className="text-white bg-black"
              icon={faWindowMaximize}
              size={"lg"}
              color={"#293042"}
              fixedWidth
            />
          </div>
        )}
        {showHashTagFilter && !report && (
          <HashTagFilter onSetFilter={onSetFilter} showTags={hashtag} />
        )}
        {showCategoryFilter && isSrl() && !report && (
          <CategoryFilter
            selectedCategory={category}
            setSelectedCategory={setCategory}
          />
        )}
        {report && (
          <div className="badge bg-primary mx-2 cursor-pointer">
            <span>Report:&nbsp;{report.name}</span>
          </div>
        )}
      </div>
    </MapControl>
  );
};

export default ButtonsControl;
